export default __webpack_public_path__ + "static/media/labelIcon.378d2a22.svg";